import ViewerPDFService from '@/modules/signers/services/viewerPDFService'
import SignupService from '@/modules/auth/services/signupService'
import ResourceServices from '@/services/ResourceServices'
import Signature from '@/models/Signature'
import ConvertBytes from '@/utils/ConvertBytes'

export default {
  namespaced: true,
  state: () => ({
    avisoPrivacidad: false,
    condicionesServicio: false,
    email: '',
    password: '',
    nombres: '',
    paterno: '',
    materno: '',
    rfc: '',
    razonSocial: '',
    tipoSuscripcion: 1,
    step: 1,
    length: 4,
    noticeOfPrivacityId: null,
    noticeOfPrivacityUrl: '',
    noticeOfPrivacityError: false,
    noticeOfPrivacityHash: null,
    numPagesNotice: 1,
    termsAndConditionsId: null,
    termsAndConditionsUrl: '',
    termsAndConditionsError: false,
    termsAndConditionsHash: null,
    numPagesTerms: 1,
    onlySignDocs: false
  }),
  mutations: {
    SET_AVISO_PRIVACIDAD(state, value) {
      state.avisoPrivacidad = value
    },
    SET_CONDICIONES_SERVICIO(state, value) {
      state.condicionesServicio = value
    },
    SET_STEP(state, step) {
      state.step = step
    },
    SET_EMAIL(state, email) {
      state.email = email
    },
    SET_PASSWORD(state, password) {
      state.password = password
    },
    SET_INFO_ADICIONAL(state, { nombres, paterno, materno }) {
      state.nombres = nombres
      state.paterno = paterno
      state.materno = materno
    },
    SET_DATOS_FISCALES(state, { rfc, razonSocial }) {
      state.rfc = rfc
      state.razonSocial = razonSocial
    },
    SET_TIPO_SUSCRIPCION(state, tipoSuscripcion) {
      state.tipoSuscripcion = tipoSuscripcion
    },
    SET_NOTICE_OF_PRIVACITY_ID(state, id) {
      state.noticeOfPrivacityId = id
    },
    SET_NOTICE_OF_PRIVACITY_URL(state, url) {
      state.noticeOfPrivacityUrl = url
    },
    SET_NOTICE_OF_PRIVACITY_ERROR(state, val) {
      state.noticeOfPrivacityError = val
    },
    SET_NOTICE_OF_PRIVACITY_HASH(state, val) {
      state.noticeOfPrivacityHash = val
    },
    SET_NUM_PAGES_NOTICE(state, pages) {
      state.numPagesNotice = pages
    },
    SET_TERMS_AND_CONDITIONS_ID(state, id) {
      state.termsAndConditionsId = id
    },
    SET_TERMS_AND_CONDITIONS_URL(state, url) {
      state.termsAndConditionsUrl = url
    },
    SET_TERMS_AND_CONDITIONS_ERROR(state, val) {
      state.termsAndConditionsError = val
    },
    SET_TERMS_AND_CONDITIONS_HASH(state, val) {
      state.termsAndConditionsHash = val
    },
    SET_NUM_PAGES_TERMS(state, pages) {
      state.numPagesTerms = pages
    },
    SET_ONLY_SiGN_DOCS(state, only) {
      state.onlySignDocs = only
    }
  },
  actions: {
    checkAvisoPrivacidad({ commit }, value) {
      commit('SET_AVISO_PRIVACIDAD', value)
    },
    checkCondicionesServicio({ commit }, value) {
      commit('SET_CONDICIONES_SERVICIO', value)
    },
    setUserPassword({ commit }, { email, password }) {
      commit('SET_EMAIL', email)
      commit('SET_PASSWORD', password)
    },
    setInfoAdicional({ commit }, { nombres, paterno, materno }) {
      commit('SET_INFO_ADICIONAL', {
        nombres,
        paterno,
        materno
      })
    },
    setDatosFiscales({ commit }, { rfc, razonSocial }) {
      commit('SET_DATOS_FISCALES', {
        rfc,
        razonSocial
      })
    },
    setTipoSuscripcion({ commit }, tipoSuscripcion) {
      commit('SET_TIPO_SUSCRIPCION', tipoSuscripcion)
    },
    goNext({ commit, state }) {
      if (state.step < state.length) {
        commit('SET_STEP', state.step + 1)
      }
    },
    goBack({ commit, state }) {
      if (state.step > 1) {
        commit('SET_STEP', state.step - 1)
      }
    },
    loadNoticeOfPrivacy({ commit }, data) {
      const service = new ViewerPDFService()
      service
        .downloadPDF(data.presigned)
        .promise.then(resp => {
          commit('SET_NOTICE_OF_PRIVACITY_ID', data.id)
          commit('SET_NOTICE_OF_PRIVACITY_URL', data.presigned)
          commit('SET_NUM_PAGES_NOTICE', resp.numPages)
        })
        .catch(err => {
          commit('SET_NOTICE_OF_PRIVACITY_ERROR', true)
        })

      const converter = new ConvertBytes()
      converter.buildHash(data.presigned)
        .then(resp => {
          commit('SET_NOTICE_OF_PRIVACITY_HASH', resp.computeHash)
        })
    },
    loadTermsAndConditions({ commit }, data) {
      const service = new ViewerPDFService()
      service
        .downloadPDF(data.presigned)
        .promise.then(resp => {
          commit('SET_TERMS_AND_CONDITIONS_ID', data.id)
          commit('SET_TERMS_AND_CONDITIONS_URL', data.presigned)
          commit('SET_NUM_PAGES_TERMS', resp.numPages)
        })
        .catch(err => {
          commit('SET_TERMS_AND_CONDITIONS_ERROR', true)
        })
      
      const converter = new ConvertBytes()
      converter.buildHash(data.presigned)
        .then(resp => {
          commit('SET_TERMS_AND_CONDITIONS_HASH', resp.computeHash)
        })
    },
    markOnlySignDocs({ commit }) {
      commit('SET_ONLY_SiGN_DOCS', true)
    },
    async signAccountDocuments({ state }, fiel) {
      const signatureObj = new Signature(
        fiel._publicCertificate,
        fiel._privateKey,
        fiel._passwordPrivateKey
      )
      const termsAndConditions = await signatureObj.signature(
        state.termsAndConditionsUrl
      )
      const noticeOfPrivacy = await signatureObj.signature(
        state.noticeOfPrivacityUrl
      )

      if (termsAndConditions != null && noticeOfPrivacy != null) {
        const resourceServ = new ResourceServices()

        const _acuerdoServicio = {
          resourceId: state.termsAndConditionsId+'',
          hash: state.termsAndConditionsHash,
          firma: termsAndConditions,
          key: resourceServ._termsAndConditions
        }
        const _avisoPrivacidad = {
          resourceId: state.noticeOfPrivacityId+'',
          hash: state.noticeOfPrivacityHash,
          firma: noticeOfPrivacy,
          key: resourceServ._noticeOfPrivacy
        }
        
        const dataParam = {
          certificado: fiel._publicCertificate,
          acuerdoServicio: JSON.stringify(_acuerdoServicio),
          avisoPrivacidad: JSON.stringify(_avisoPrivacidad)
        }

        const signupServ = new SignupService()
        return signupServ.signAccountDocuments(dataParam)
      }
    }
  },
  getters: {
    avisoPrivacidad(state) {
      return state.avisoPrivacidad
    },
    condicionesServicio(state) {
      return state.condicionesServicio
    },
    canGoNext(state) {
      switch (state.step) {
        case 1:
          return state.avisoPrivacidad && state.condicionesServicio
        case 2:
          return state.email.length > 0 && state.password.length > 0
        case 3:
          return (
            state.nombres.length > 0 &&
            state.paterno.length > 0 &&
            state.rfc.length > 0 &&
            state.razonSocial.length > 0
          )
        case 4:
          return state.tipoSuscripcion === 1 || state.tipoSuscripcion === 2
        case 5:
          return true
      }
    },
    wizardStep(state) {
      return state.step
    },
    wizardLength(state) {
      return state.length
    },
    tipoSuscripcion(state) {
      return state.tipoSuscripcion
    },
    account(state) {
      return {
        nombres: state.nombres,
        paterno: state.paterno,
        materno: state.materno,
        rfc: state.rfc,
        razonSocial: state.razonSocial,
        email: state.email,
        password: state.password,
        tipoSuscripcion: state.tipoSuscripcion
      }
    },
    noticeOfPrivacityUrl(state) {
      return state.noticeOfPrivacityUrl
    },
    numPagesNotice(state) {
      return state.numPagesNotice
    },
    termsAndConditionsUrl(state) {
      return state.termsAndConditionsUrl
    },
    numPagesTerms(state) {
      return state.numPagesTerms
    },
    onlySignDocs(state) {
      return state.onlySignDocs
    }
  }
}
